import { EventTypes, track } from '@mc/track-event'

export const trackArticleViewed = (article) => {
  const viewProperties = {
    category: article.category.name,
    'featured-instructor': article.featuredCourseSlug,
    path: window.location.pathname,
    platform: 'next',
    'publish-month': article.articleStructuredData[0].datePublished,
    social_retargeting_category: article.mcCategorySlug,
    title: article.title,
  }

  track(EventTypes.ARTICLE_VIEWED, viewProperties, {
    integrations: {
      'Google Analytics': false,
    },
  })
}

export const trackCategoryCarouselClick = (category) => {
  track(EventTypes.ARTICLE_PAGE_CLICK, {
    location: 'article-page-body',
    category: 'article-nav-header',
    name: category.name,
  })
}

export const trackBookmarkClick = () => {
  track(EventTypes.ARTICLE_PAGE_CLICK, {
    location: 'article-page-body',
    category: 'article-bookmark-button',
  })
}
